<template>

        <div class="head">
        <div class="head-left">
            <img src="../assets/logo.png" alt="" >
            <p style="cursor: pointer;">武汉芸希信息科技有限公司</p>
        </div>
        <div class="head-right">
          
              <el-dropdown placement="bottom-end" @command="infoRouter">
                 <div class="head-right-img">
                <img src="../assets/avatar.png" alt="">
                     </div>
               <el-dropdown-menu slot="dropdown" style="margin-left:70px;">
                 <el-dropdown-item command="info">个人中心</el-dropdown-item>
                 <el-dropdown-item command="quit">退出登陆</el-dropdown-item>
            
               </el-dropdown-menu>
              </el-dropdown>
             
              
      
            <!-- <i class="el-icon-caret-bottom"></i> -->
              
        </div>
    </div>

   
</template>
<script>
import {removeToken} from '@/api/token.js'
export default {
    data() {
     return{
      
     }
  },
  methods:{
     infoRouter(key){
       if(key==='info'){
          this.$router.push('/Portal/Infor')
       }else{
        removeToken()
        this.$router.push('/')
       }
       
     }
  }
}
</script>
<style lang="scss" scoped>

  .head{
      height:70px;
      width: 100%;
      background: #001529;
      display: flex;
      justify-content:space-between;
      box-shadow: 10px 5px 20px #888888;
  }
  .head-left{
     width: 400px;
     height: 100%;
    //  background: red; 
     line-height: 100%;
     display: flex;
     align-items:center;
     p{
         margin: 0;
         color: #fff;
         margin-left: 20px;
     }
     img{
         height: 40px;
         width: 40px;
          margin-left: 20px;
     }
  }
  .head-right{
      float: right;
      width: 300px;
      height: 100%;
    //   background: red;
      display: flex;
      align-items: center;
    .head-right-img{
        margin-left: 150px;
     width: 60px;
     height: 60px;
     border-radius: 50%;
     overflow: hidden;
       img{
           width: 100%;
           height: 100%;
       }
    }
 
    .el-dropdown-menu{
      right: 20px !important;
    }
  }
 
</style>